
(function () {
    var homePageFn = {
      /**
       * 首页 Featured Collection 注入商品
       * @param {Object} [opts]
       * @param {Element} [opts.sectionEl] - 仅刷新该区块（主题编辑器内单实例），对应 .ws-featured-collection[data-section-type]
       * @param {Element} [opts.listingDom] - 仅刷新该 listing 容器（.ws-featured-collection-listing）
       */
      insertCollectionModule: function (opts) {
        opts = opts || {};
        var collectionModel;
        if (opts.listingDom) {
          collectionModel = [opts.listingDom];
        } else if (opts.sectionEl) {
          var listing = opts.sectionEl.querySelector && opts.sectionEl.querySelector('.ws-featured-collection-listing');
          collectionModel = listing ? [listing] : [];
        } else {
          collectionModel = Array.from($('.ws-featured-collection').find('.ws-featured-collection-listing'));
        }
        try {
          collectionModel &&
            collectionModel.length > 0 &&
            collectionModel.forEach(function (item) {
              if (opts.sectionEl || opts.listingDom) {
                $(item).find('.ws-featured-collection-product-list').empty();
              }
              WS.ui.collectionFn.getCollectionModule({
                dom: item,
              });
            });
        } catch (e) {
          console.log(e);
        }
      },
      /**
       * 社媒列表底部进度条同步：根据横向滚动比例更新 thumb 位置，同时刷新左右箭头状态。
       */
      updateSocialModuleScrollbar: function (sectionDom) {
        var $section = $(sectionDom);
        var $list = $section.find('.ws-social-module__list-wrapper').first();
        var $bar = $section.find('.ws-social-module__scrollbar').first();
        var $thumb = $bar.find('.ws-featured-collection-scrollbar__thumb').first();
        homePageFn.updateSocialModuleArrows(sectionDom);
        if (!$list.length || !$bar.length || !$thumb.length) return;

        var listEl = $list.get(0);
        var barEl = $bar.get(0);
        if (!listEl || !barEl) return;

        var scrollWidth = listEl.scrollWidth || 0;
        var clientWidth = listEl.clientWidth || 0;
        if (scrollWidth <= clientWidth || clientWidth <= 0) {
          $bar.hide();
          return;
        }

        $bar.show();
        var ratio = clientWidth / scrollWidth;
        var barWidth = barEl.clientWidth || 0;
        var minThumbWidth = 36;
        var thumbWidth = Math.max(Math.round(barWidth * ratio), minThumbWidth);
        thumbWidth = Math.min(thumbWidth, barWidth);
        $thumb.css({ width: thumbWidth + 'px' });

        var maxListScroll = scrollWidth - clientWidth;
        var maxThumbMove = Math.max(barWidth - thumbWidth, 0);
        var left = maxListScroll > 0 ? (listEl.scrollLeft / maxListScroll) * maxThumbMove : 0;
        $thumb.css({ transform: 'translateX(' + left + 'px)' });
      },
      /**
       * 社媒列表左右箭头状态：不可滚动、最左、最右时置灰并禁用边界点击。
       */
      updateSocialModuleArrows: function (sectionDom) {
        var $section = $(sectionDom);
        var $list = $section.find('.ws-social-module__list-wrapper').first();
        var $prev = $section.find('.ws-social-module__arrow--prev').first();
        var $next = $section.find('.ws-social-module__arrow--next').first();
        if (!$list.length || !$prev.length || !$next.length) return;

        var listEl = $list.get(0);
        if (!listEl) return;

        var scrollWidth = listEl.scrollWidth || 0;
        var clientWidth = listEl.clientWidth || 0;
        var scrollLeft = listEl.scrollLeft || 0;
        var epsilon = 2;

        if (scrollWidth <= clientWidth + epsilon) {
          $prev.prop('disabled', true).addClass('is-disabled').attr('aria-disabled', 'true');
          $next.prop('disabled', true).addClass('is-disabled').attr('aria-disabled', 'true');
          return;
        }

        var atStart = scrollLeft <= epsilon;
        var atEnd = scrollLeft + clientWidth >= scrollWidth - epsilon;
        $prev.prop('disabled', atStart).toggleClass('is-disabled', atStart).attr('aria-disabled', atStart ? 'true' : 'false');
        $next.prop('disabled', atEnd).toggleClass('is-disabled', atEnd).attr('aria-disabled', atEnd ? 'true' : 'false');
      },
      /**
       * 社媒列表箭头滚动：每次移动约一屏，目标位置限制在可滚动范围内，不做循环。
       */
      scrollSocialModuleList: function (listEl, direction) {
        if (!listEl) return;
        var maxScroll = Math.max((listEl.scrollWidth || 0) - (listEl.clientWidth || 0), 0);
        var distance = Math.max((listEl.clientWidth || 0) * 0.85, 1);
        var target = (listEl.scrollLeft || 0) + distance * direction;
        target = Math.max(0, Math.min(target, maxScroll));
        if (typeof listEl.scrollTo === 'function') {
          listEl.scrollTo({ left: target, behavior: 'smooth' });
        } else {
          listEl.scrollLeft = target;
        }
      },
      reportInsideNjWorldShow: function(sectionDom) {
        if (!sectionDom || sectionDom.__wsInsideNjWorldShowReported || !window.WS || !WS.stat || !WS.ui || !WS.ui.reportType) return;
        var reportShow = function() {
          if (sectionDom.__wsInsideNjWorldShowReported) return;
          sectionDom.__wsInsideNjWorldShowReported = true;
          WS.stat({
            eid: WS.ui.reportType['moduleShow'],
            event_name: 'inside_nj_world'
          });
        };
        if (WS.observe && WS.observe.intersection) {
          WS.observe.intersection(sectionDom, function(entries, observer) {
            for (var i = 0, len = entries.length; i < len; i++) {
              if (entries[i].isIntersecting) {
                observer.unobserve(entries[i].target);
                reportShow();
              }
            }
          }, { threshold: [0.5] });
        } else {
          reportShow();
        }
      },
      initSocialModuleReport: function(root) {
        var $root = root ? $(root) : $(document);
        $root.find('.ws-social-module').each(function() {
          homePageFn.reportInsideNjWorldShow(this);
          $(this).find('.ws-social-module__card').each(function(index) {
            var cardDom = this;
            $(cardDom).attr('data-social-pos', index + 1);
            if (cardDom.__wsSocialPostShowBound) return;
            cardDom.__wsSocialPostShowBound = true;
            var reportPostShow = function() {
              if (cardDom.__wsSocialPostShowReported) return;
              cardDom.__wsSocialPostShowReported = true;
              WS.ui.reportSocialEvent && WS.ui.reportSocialEvent('socia_post_show', WS.ui.reportType['moduleShow'], cardDom, { includePosition: true });
            };
            if (WS.observe && WS.observe.intersection) {
              WS.observe.intersection(cardDom, function(entries, observer) {
                for (var i = 0, len = entries.length; i < len; i++) {
                  if (entries[i].isIntersecting) {
                    observer.unobserve(entries[i].target);
                    reportPostShow();
                  }
                }
              }, { threshold: [0.5] });
            } else {
              reportPostShow();
            }
          });
        });
      },
      /**
       * 初始化社媒列表滚动行为：绑定横向滚动、图片加载、箭头点击和 resize 同步。
       */
      initSocialModuleScrollbar: function (root) {
        var $root = root ? $(root) : $(document);
        $root.find('.ws-social-module').each(function () {
          var section = this;
          var $list = $(section).find('.ws-social-module__list-wrapper').first();
          if (!$list.length) return;

          var sync = function () {
            homePageFn.updateSocialModuleScrollbar(section);
          };
          sync();
          if (window.requestAnimationFrame) {
            window.requestAnimationFrame(function () {
              window.requestAnimationFrame(sync);
            });
          }
          setTimeout(sync, 80);
          setTimeout(sync, 400);

          $list
            .off('scroll.wsSocialScrollbar')
            .on('scroll.wsSocialScrollbar', sync);
          $(section)
            .find('.ws-social-module__card-media img')
            .off('load.wsSocialScrollbar')
            .on('load.wsSocialScrollbar', sync);
        });

        $(document)
          .off('click.wsSocialModuleArrow', '.ws-social-module__arrow')
          .on('click.wsSocialModuleArrow', '.ws-social-module__arrow', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $btn = $(this);
            if ($btn.hasClass('is-disabled') || $btn.prop('disabled')) return;

            var $section = $btn.closest('.ws-social-module');
            var listEl = $section.find('.ws-social-module__list-wrapper').get(0);
            if (!listEl) return;

            homePageFn.scrollSocialModuleList(listEl, $btn.hasClass('ws-social-module__arrow--next') ? 1 : -1);
            var sync = function () {
              homePageFn.updateSocialModuleScrollbar($section.get(0));
            };
            sync();
            setTimeout(sync, 450);
          });

        $(window)
          .off('resize.wsSocialScrollbar')
          .on('resize.wsSocialScrollbar', function () {
            $('.ws-social-module').each(function () {
              homePageFn.updateSocialModuleScrollbar(this);
            });
          });
      },
      /**
       * 社媒弹窗描述裁剪：移动端复用 Product Details 的 Read More 测量逻辑，PC 端展示完整文案。
       */
      initSocialModulePopupDesc: function (root) {
        if (!window.WS || !WS.ui || !WS.ui.initTextReadMore) return;
        var $root = root ? $(root) : $(document);
        var isDesktop = function () {
          return typeof window.matchMedia === 'function' && window.matchMedia('(min-width: 750px)').matches;
        };
        var reset = function () {
          $root.find('.js-social-module-popup-desc').each(function () {
            var $desc = $(this);
            var fullText = $desc.attr('data-full-text') || '';
            $desc.find('.ws-social-module-popup__desc-text').text(fullText).attr('data-collapsed', 'false');
            $desc.find('.ws-social-module-popup__desc-read-more').hide().attr('aria-expanded', 'false');
            $desc.find('.ws-social-module-popup__desc-collapse').hide().attr('aria-expanded', 'false');
            $desc.find('.ws-social-module-popup__desc-wrap').removeAttr('data-ws-readmore-ready');
          });
        };
        var sync = function () {
          if (isDesktop()) {
            // PC 端不做两行裁剪，避免出现移动端的 "... >>"。
            reset();
            return;
          }
          WS.ui.initTextReadMore({
            blockSelector: '.js-social-module-popup-desc',
            wrapSelector: '.ws-social-module-popup__desc-wrap',
            textSelector: '.ws-social-module-popup__desc-text',
            readMoreSelector: '.ws-social-module-popup__desc-read-more',
            collapseSelector: '.ws-social-module-popup__desc-collapse',
            maxLines: 2,
            lineHeightFallbackMultiplier: 1.16,
            fullTextAttr: 'data-full-text'
          });
          $('.js-social-module-popup-desc .ws-social-module-popup__desc-read-more').each(function () {
            var $readMore = $(this);
            if ($readMore.css('display') !== 'none') $readMore.css('display', 'inline');
          });
        };
        sync();
        setTimeout(sync, 80);
        setTimeout(sync, 250);
        $(window)
          .off('resize.wsSocialPopupDesc')
          .on('resize.wsSocialPopupDesc', function () {
            sync();
          });
      },
      /**
       * 同步弹窗图片轮播状态：根据当前 index 更新图片位置、指示点和左右箭头禁用态。
       */
      syncSocialModulePopupGallery: function (galleryDom) {
        var $gallery = $(galleryDom);
        var $track = $gallery.find('.ws-social-module-popup__image-track').first();
        var $slides = $gallery.find('.ws-social-module-popup__image-slide');
        var $dots = $gallery.find('.ws-social-module-popup__gallery-dot');
        var $prev = $gallery.find('.ws-social-module-popup__gallery-arrow--prev');
        var $next = $gallery.find('.ws-social-module-popup__gallery-arrow--next');
        var track = $track.get(0);
        var count = $dots.length || $slides.length;
        if (!track || !count) return;

        var gallery = $gallery.get(0);
        var index = typeof gallery.__wsSocialGalleryIndex === 'number'
          ? gallery.__wsSocialGalleryIndex
          : parseInt($gallery.attr('data-active-index') || 0, 10);
        if (isNaN(index)) index = 0;
        index = Math.max(0, Math.min(index, count - 1));

        gallery.__wsSocialGalleryIndex = index;
        $gallery.attr('data-active-index', index);
        track.scrollLeft = (track.clientWidth || 0) * index;
        $slides.removeClass('is-active').filter('[data-slide-index="' + index + '"]').addClass('is-active');
        $slides.not('.is-active').find('.ws-social-module-popup__video').each(function () {
          this.pause();
        });
        $dots.removeClass('is-active').eq(index).addClass('is-active');
        if (index === 0) {
          $prev.addClass('is-disabled').attr('aria-disabled', 'true');
        } else {
          $prev.removeClass('is-disabled').attr('aria-disabled', 'false');
        }
        if (index === count - 1) {
          $next.addClass('is-disabled').attr('aria-disabled', 'true');
        } else {
          $next.removeClass('is-disabled').attr('aria-disabled', 'false');
        }
      },
      /**
       * 弹窗图片轮播跳转：只允许在首尾范围内切换，不循环到另一端。
       */
      goToSocialModulePopupGallery: function (galleryDom, index) {
        var $gallery = $(galleryDom);
        var $track = $gallery.find('.ws-social-module-popup__image-track').first();
        var track = $track.get(0);
        var $dots = $gallery.find('.ws-social-module-popup__gallery-dot');
        var count = $dots.length || $gallery.find('.ws-social-module-popup__image-slide').length;
        var gallery = $gallery.get(0);
        if (!track || !count) return;

        if (index < 0) index = 0;
        if (index >= count) index = count - 1;
        gallery.__wsSocialGalleryIndex = index;
        track.scrollLeft = (track.clientWidth || 0) * index;
        homePageFn.syncSocialModulePopupGallery(gallery);
      },
      /**
       * 初始化弹窗图片轮播：清理旧 transform 状态，只保留按钮和指示点点击切换。
       */
      initSocialModulePopupGallery: function (root) {
        var $root = root ? $(root) : $(document);
        $root.find('.ws-social-module-popup__image-gallery').each(function () {
          var gallery = this;
          var $track = $(gallery).find('.ws-social-module-popup__image-track').first();
          if (!$track.length) return;
          if (gallery.__wsSocialGalleryReady) {
            homePageFn.syncSocialModulePopupGallery(gallery);
            return;
          }

          gallery.__wsSocialGalleryReady = true;
          gallery.__wsSocialGalleryIndex = 0;

          var track = $track.get(0);
          $track.css({
            '-webkit-transform': '',
            transform: '',
            '-webkit-transition-duration': '',
            transitionDuration: ''
          });
          track.scrollLeft = 0;

          $track
            .off('scroll.wsSocialPopupGallery touchend.wsSocialPopupGallery mousedown.wsSocialPopupGallery dragstart.wsSocialPopupGallery')
            .on('dragstart.wsSocialPopupGallery', '.ws-social-module-popup__image', function (e) {
              e.preventDefault();
            });
          homePageFn.syncSocialModulePopupGallery(gallery);
          setTimeout(function () {
            homePageFn.syncSocialModulePopupGallery(gallery);
          }, 100);
        });
        $(window)
          .off('resize.wsSocialPopupGallery')
          .on('resize.wsSocialPopupGallery', function () {
            $('.ws-social-module-popup__image-gallery').each(function () {
              homePageFn.syncSocialModulePopupGallery(this);
            });
          });
      },
      /**
       * 主题编辑器：Featured List 变更时仅刷新对应 section（同页多块时依赖 event 中的 sectionId；也可在别处用 initShopifyEditorEvent + sectionRootClass）
       */
      bindFeaturedCollectionEditorEvent: function () {
        if (typeof WS === 'undefined' || !WS.ui || !WS.ui.initShopifyEditorEvent) return;
        WS.ui.initShopifyEditorEvent({
          sectionType: 'ws-featured-collection',
          callback: function (event, payload) {
            if (payload.sectionEl) {
              homePageFn.insertCollectionModule({ sectionEl: payload.sectionEl });
            } else {
              homePageFn.insertCollectionModule();
            }
          },
        });
      },
      /** 主题编辑器：slideshow 区块变更时重初始化轮播（逻辑见 WS.ui.initShopifyEditorEvent */
      bindSlideshowEditorEvent: function() {
        if (typeof WS === 'undefined' || !WS.ui || !WS.ui.initShopifyEditorEvent) return;
        WS.ui.initShopifyEditorEvent({
          sectionType: 'slideshow',
          callback: function () {
            homePageFn.initSlider();
            homePageFn.initSlideshowVideo();
          },
        });
      },
      isSlideshowElVisible: function (el) {
        if (!el) return false;
        var style = window.getComputedStyle ? window.getComputedStyle(el) : null;
        if (!style) return true;
        return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
      },
      getSlideshowSlides: function ($slideshow) {
        if (!$slideshow || !$slideshow.length) return [];
        var sliderInst = $slideshow[0] && $slideshow[0].__wsSlider;
        if (sliderInst && sliderInst.slides && sliderInst.slides.length) {
          return Array.prototype.slice.call(sliderInst.slides);
        }
        return $slideshow.find('.ws-slideshow-model > .ws-slideshow-imagebox-link').toArray();
      },
      getSlideshowActiveIndex: function ($slideshow) {
        var slides = homePageFn.getSlideshowSlides($slideshow);
        var slideLength = slides.length;
        if (!slideLength) return 0;
        var sliderInst = $slideshow[0] && $slideshow[0].__wsSlider;
        var index = sliderInst && typeof sliderInst.getIndex === 'function' ? sliderInst.getIndex() : 0;
        index = parseInt(index, 10);
        if (isNaN(index)) index = 0;
        if (index < 0) index = slideLength - 1;
        if (index >= slideLength) index = 0;
        return index;
      },
      getSlideshowVisibleVideoTrack: function ($slide) {
        if (!$slide || !$slide.length) return $();
        return $slide.find('.ws-slideshow-video-track:visible').first();
      },
      prepareSlideshowVideo: function (videoCtn) {
        if (!videoCtn) return;
        if (!videoCtn.__wsVideoStateBound) {
          videoCtn.__wsVideoStateBound = true;
          var markFrameReady = function () {
            videoCtn.setAttribute('data-ws-frame-ready', '1');
          };
          videoCtn.addEventListener('loadeddata', markFrameReady);
          videoCtn.addEventListener('playing', markFrameReady);
        }
        videoCtn.muted = true;
        videoCtn.loop = true;
        videoCtn.playsInline = true;
        videoCtn.setAttribute('muted', 'muted');
        videoCtn.setAttribute('playsinline', 'true');
        videoCtn.setAttribute('webkit-playsinline', 'true');
        videoCtn.setAttribute('preload', 'auto');
        if (videoCtn.readyState === 0 && typeof videoCtn.load === 'function') {
          videoCtn.load();
        }
      },
      pauseSlideshowVideo: function ($slide) {
        if (!$slide || !$slide.length) return;
        var $track = homePageFn.getSlideshowVisibleVideoTrack($slide);
        $slide.find('video.slide-item_video').each(function () {
          this.pause();
          var keepFrame = $track.length && $.contains($track.get(0), this) && this.getAttribute('data-ws-frame-ready') === '1';
          $(this)[keepFrame ? 'show' : 'hide']();
        });
        $slide.find('.video-play').hide();
        $slide.find('.video-pause').hide();
      },
      playSlideshowVideo: function ($slide) {
        if (!$slide || !$slide.length) return;
        var $track = homePageFn.getSlideshowVisibleVideoTrack($slide);
        if (!$track.length) return;
        var videoCtn = $track.find('.video-container').get(0);
        if (!videoCtn) return;
        $slide.find('video.slide-item_video').each(function () {
          if (this !== videoCtn) {
            this.pause();
            $(this).hide();
          }
        });
        homePageFn.prepareSlideshowVideo(videoCtn);
        $(videoCtn).show();
        $slide.find('.video-play, .video-pause').hide();
        var playPromise = videoCtn.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      },
      warmSlideshowVideo: function ($slide) {
        if (!$slide || !$slide.length || !$slide.hasClass('ws-slideshow-imagebox-link--video')) return;
        var $track = homePageFn.getSlideshowVisibleVideoTrack($slide);
        if (!$track.length) return;
        homePageFn.prepareSlideshowVideo($track.find('.video-container').get(0));
      },
      syncSlideshowVideos: function ($slideshow, activeIndex) {
        var slides = homePageFn.getSlideshowSlides($slideshow);
        if (!slides.length) return;
        $(slides).each(function (index, slideEl) {
          var $slide = $(slideEl);
          if (index === activeIndex && $slide.hasClass('ws-slideshow-imagebox-link--video')) {
            homePageFn.playSlideshowVideo($slide);
          } else {
            homePageFn.pauseSlideshowVideo($slide);
          }
        });
        if (activeIndex >= 0 && slides.length > 1) {
          homePageFn.warmSlideshowVideo($(slides[(activeIndex + 1) % slides.length]));
        }
      },
      syncSlideshowHeaderBackground: function ($slideshow, activeIndex) {
        var slides = homePageFn.getSlideshowSlides($slideshow);
        if (!slides.length) return;
        activeIndex = parseInt(activeIndex, 10);
        if (isNaN(activeIndex)) activeIndex = 0;
        activeIndex = ((activeIndex % slides.length) + slides.length) % slides.length;

        var slide = slides[activeIndex];
        var enabled = slide.getAttribute('data-ws-header-bg-enabled') === 'true';
        var background = slide.getAttribute('data-ws-header-bg') || '';
      },
      syncAllSlideshowVideos: function () {
        $('.ws-slideshow').each(function () {
          var $slideshow = $(this);
          if (!homePageFn.isSlideshowElVisible(this)) {
            homePageFn.syncSlideshowVideos($slideshow, -1);
            return;
          }
          homePageFn.syncSlideshowVideos($slideshow, homePageFn.getSlideshowActiveIndex($slideshow));
        });
      },
      initSlideshowVideo: function () {
        $(window)
          .off('resize.wsSlideshowVideo orientationchange.wsSlideshowVideo')
          .on('resize.wsSlideshowVideo orientationchange.wsSlideshowVideo', function () {
            homePageFn.syncAllSlideshowVideos();
          });
        homePageFn.syncAllSlideshowVideos();
      },
      initSlider: function() {
        // 首页组件曝光
        // 同页可能存在多个 ws-slideshow（例如移动端/PC 各一套），需要按“当前可见实例”分别初始化。
        var $sliders = $('.ws-slideshow');

        // 初始化每个可见的 slideshow 实例
        $sliders.each(function () {
          var $container = $(this);
          if (!homePageFn.isSlideshowElVisible(this)) return;
          if (!this.id) return;

          var slideLength = $container.find('.ws-slideshow-model > .ws-slideshow-imagebox-link').length;
          homePageFn.syncSlideshowHeaderBackground($container, 0);
          if (!slideLength) return;
          var syncAccess = function(index) {
            var normalized = ((index % slideLength) + slideLength) % slideLength;
            var originalSlides = this.__wsSlider && this.__wsSlider.slides ? this.__wsSlider.slides : $container.find('.ws-slideshow-model > .ws-slideshow-imagebox-link').toArray();
            Array.prototype.forEach.call(originalSlides, function(slide, position) {
              var active = position === normalized;
              slide.setAttribute('aria-hidden', active ? 'false' : 'true');
              if (slide.tagName === 'A') slide.tabIndex = active ? 0 : -1;
              slide.querySelectorAll('a[href],button,input,select').forEach(function(control) { control.tabIndex = active ? 0 : -1; });
            });
            $container.find('.slide-index-item').each(function(position) {
              var active = position === normalized;
              this.setAttribute('aria-current', active ? 'true' : 'false');
              this.setAttribute('aria-label', (active ? 'Current slide ' : 'Show slide ') + (position + 1));
            });
          }.bind(this);
          syncAccess(0);
          if (slideLength <= 1) return;

          // 显示 icon（只在当前容器内）
          $container.find('.slide-status-btn-icon').attr('style', 'display: flex;');

          var sliderId = this.id;
          var slideshowRoot = $container[0];
          if (slideshowRoot && slideshowRoot.__wsSlider && typeof slideshowRoot.__wsSlider.stopAuto === 'function') {
            slideshowRoot.__wsSlider.stopAuto();
          }
          var slider = new WS.Slider({
            container: '#' + sliderId,
            wrapper: '.ws-slideshow-model',
            slide: '.ws-slideshow-imagebox-link',
            direction: 'x',
            isLoop: true,
            isAuto: true,
            slideSpeed: 600,
            autoInter: 6000,
            endCallback: function (index) {
              var $current = $('#' + sliderId);
              var normalized = ((index % slideLength) + slideLength) % slideLength;
              var focusedSlide = slideshowRoot.contains(document.activeElement) && document.activeElement.closest('.ws-slideshow-imagebox-link');
              $current.find('.slide-index-item').eq(normalized).addClass('active').siblings().removeClass('active');
              syncAccess(index);
              if (focusedSlide && focusedSlide.getAttribute('aria-hidden') === 'true') {
                slider.slides[normalized].focus();
              }
              homePageFn.syncSlideshowVideos($current, index);
              homePageFn.syncSlideshowHeaderBackground($current, index);
            }
          });
          // Zepto 的 .data() 走 data-* 属性，存对象会变成普通数据，Slider.prototype.slideTo 会丢失；挂 DOM 引用
          if (slideshowRoot) slideshowRoot.__wsSlider = slider;
          Array.prototype.forEach.call(slider.wrapper.children, function(slide, index) {
            if (index < slider.copyNumber || index >= slider.copyNumber + slideLength) {
              slide.setAttribute('aria-hidden', 'true');
              slide.inert = true;
              if (slide.tagName === 'A') slide.tabIndex = -1;
            }
          });
          $container.on('focusin', function() { slider.stopAuto(); slider.isAuto = false; });
          $container.on('focusout', function(event) {
            if (this.contains(event.relatedTarget) || this.__wsUserPaused) return;
            slider.isAuto = true;
            slider.startAuto();
          });
          $container.on('click', '.ws-slideshow-pause', function() {
            slideshowRoot.__wsUserPaused = !slideshowRoot.__wsUserPaused;
            this.setAttribute('aria-pressed', slideshowRoot.__wsUserPaused ? 'true' : 'false');
            this.setAttribute('aria-label', 'Pause automatic slideshow');
            this.textContent = slideshowRoot.__wsUserPaused ? 'Play' : 'Pause';
            slider.stopAuto();
            slider.isAuto = !slideshowRoot.__wsUserPaused && !slideshowRoot.contains(document.activeElement);
            if (slider.isAuto) slider.startAuto();
          });
          $container.on('click', '.slide-icon-left', function() { slider.slideTo(slider.getIndex() - 1); });
          $container.on('click', '.slide-icon-right', function() { slider.slideTo(slider.getIndex() + 1); });
          homePageFn.syncSlideshowHeaderBackground($container, 0);
        });

        // 点击圆点：从对应 .ws-slideshow 根节点取 __wsSlider（与 Zepto .data 不同，可保留 WS.Slider 实例）
        $(document)
          .off('click.wsSlideshowDots', '.ws-slideshow .slide-index-item')
          .on('click.wsSlideshowDots', '.ws-slideshow .slide-index-item', function () {
            var $item = $(this);
            var sideIndex = $item.index();
            var root = $item.closest('.ws-slideshow')[0];
            var sliderInst = root && root.__wsSlider;
            if (!sliderInst || typeof sliderInst.slideTo !== 'function') return;
            $item.addClass('active').siblings().removeClass('active');
            sliderInst.slideTo(sideIndex, 300);
            homePageFn.syncSlideshowHeaderBackground($item.closest('.ws-slideshow'), sideIndex);
          });
      },
      // 首页调用方法
      homepageHandleAll: function () {

        homePageFn.initSlider();
        homePageFn.initSlideshowVideo();
        homePageFn.initSocialModuleScrollbar();
        homePageFn.initSocialModuleReport();

        // 获取首页集合图片slide的长度
        var slideBlockLength = Number($('.ws-slide-collection-images').attr('length'));
        if (slideBlockLength > 1) {

        // 滚动方法
        collectionSlider = new WS.Slider({
            container: ".ws-slide-images",
            wrapper: ".ws-slide-images_list",
            slide: ".images-list-box",
            direction: 'x',
            isLoop: true,
            isAuto: true,
            slideSpeed: 600,
            autoInter: 6000,
            endCallback: function(index) {
            // 圆点
            $('.ws-slide-images .slide-images-index-item').eq(index).addClass('active').siblings().removeClass('active');
            }
        });

        // 点击圆点
        $(document).on("click", ".ws-slide-images .slide-images-index-item",function () {
        var sideIndex = $(this).index();
        $(this).addClass('active').siblings().removeClass('active');
        collectionSlider.slideTo(sideIndex, 300);
        });
    }

        let obTargets = Array.from($("body").children('.shopify-section'));
        // 开始观察
        try {
        obTargets && obTargets.length > 0 && obTargets.forEach((item, index) => {
            if ($(item).find('.ws-report-pos-list').length > 0) {
            // 首页模块，内容坑位曝光
            var legoList = $('.ws-report-pos-list .pos-li');
            // 开始观察
            try {
                legoList && legoList.length > 0 && legoList.forEach((item2, index2) => {
                homePageFn.modelShowHandle(item2, WS.ui.homeReportMap['showHomeSection'], index, {ext3: `pos=${index2+1}`});
                })
            } catch (e) {
            }
            } else {
            homePageFn.modelShowHandle(item, WS.ui.homeReportMap['showHomeSection'], index);
            }
        })
        } catch (e) {
        console.log('showSkuPopView error => ', e);
        }

        $(document).on('click', '.ws-social-module__follow-btn', function () {
          WS.stat({
            eid: WS.ui.reportType['click'],
            ext1: 'social_follow_us'
          });
        });

        // westyle-social-module 卡片点击打开详情弹窗（使用 snippet 预渲染内容，JS 仅负责克隆与展示）
        $(document).on("click", ".ws-social-module__card", function (e) {
        e.preventDefault();
        var $card = $(this);
        homePageFn.homeComponentClickExposure(JSON.stringify({
            url: $card.data('product-url') || '',
            blogger: $card.data('blogger-name') || ''
        }), this);
        WS.ui.reportSocialEvent && WS.ui.reportSocialEvent('socia_post_click', WS.ui.reportType['click'], this, { includePosition: true });
        var blockIndex = $card.data('block-index');
        var $section = $card.closest('.ws-social-module');
        var sectionId = $section.data('section-id');
        var $templates = $section.find('.ws-social-module-popup-templates');
        var $content = $templates.find('.ws-social-module-popup-content[data-block-index="' + blockIndex + '"]');
        if (!$content.length) return;
        var $shellTpl = document.getElementById('ws-social-module-popup-shell-' + sectionId);
        if (!$shellTpl || !$shellTpl.content) return;
        var $popup = $($shellTpl.content.cloneNode(true));
        var socialTrackData = WS.ui.getSocialPostTrackData ? WS.ui.getSocialPostTrackData(this) : {};
        var $popupRoot = $popup.filter('.ws-vertical-popupbox-social-module').first();
        if (!$popupRoot.length) {
          $popupRoot = $popup.find('.ws-vertical-popupbox-social-module').first();
        }
        if (socialTrackData.postId) $popupRoot.attr('data-social-post-id', socialTrackData.postId);
        if (socialTrackData.platform) $popupRoot.attr('data-social-platform', socialTrackData.platform);
        if (socialTrackData.pos) $popupRoot.attr('data-social-pos', socialTrackData.pos);
        $popupRoot.find('.ws-social-module-popup__content-slot').append($content.contents().clone());
        $('body').append($popup);
        WS.ui.reportSocialEvent && WS.ui.reportSocialEvent('socia_post_pop', WS.ui.reportType['moduleShow'], $popupRoot, { includePosition: true });
        WS.ui.initSocialPopupProductExposure && WS.ui.initSocialPopupProductExposure($popupRoot);
        homePageFn.initSocialModulePopupGallery($popupRoot);
        homePageFn.initSocialModulePopupDesc($popupRoot);
        WS.ui.popupNoScrollHandle();
        WS.ui.operateZeSnippet && WS.ui.operateZeSnippet(1);
        });

        // westyle-social-module 商品卡右侧加购：商品卡本身保持跳转，只有 icon 调起集合页同款加购弹窗。
        $(document).on('click', '.ws-social-module-popup__product-action', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var $btn = $(this);
          var productId = $btn.attr('data-product-id');
          var $product = $btn.closest('.ws-social-module-popup__product');
          var $productDataDom = $product.find('.js-social-product-json').first();
          if (!productId || !$productDataDom.length || !WS.ui || !WS.ui.productPopupFn || !WS.ui.productPopupFn.lsCreatePopupHandle) return;

          var productInfo;
          try {
            productInfo = WS.ui.getProductData(productId, $productDataDom);
          } catch (err) {
            WS.ui.toastShowHandle && WS.ui.toastShowHandle(WS.ui.errorMsgMap && WS.ui.errorMsgMap.baseError);
            return;
          }
          if (!productInfo || !productInfo.id) return;

          var socialTrackData = WS.ui.getSocialPostTrackData ? WS.ui.getSocialPostTrackData(this) : {};
          WS.ui.operateZeSnippet && WS.ui.operateZeSnippet(1);
          WS.ui.productPopupFn.lsCreatePopupHandle({
            data: productInfo,
            handle: 'social-module',
            listType: 'social-module',
            aid: 'social-module',
            socialPostId: socialTrackData.postId,
            socialPlatform: socialTrackData.platform,
            socialPos: socialTrackData.pos,
            socialProductId: productInfo.id,
            dataDom: this
          });
          if (WS.ui.productPopupFn.addToBagReportExposureClickHanlde && WS.ui.reportType && WS.ui.productReportMap) {
            WS.ui.productPopupFn.addToBagReportExposureClickHanlde(productInfo, WS.ui.reportType['click'], WS.ui.productReportMap['clickAddtobagIcon']);
          }
        });

        $(document).on('keydown', '.ws-social-module-popup__product-action', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).trigger('click');
          }
        });

        $(document).on('click', '.ws-social-module-popup__gallery-arrow', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if ($(this).hasClass('is-disabled')) return;
          var $gallery = $(this).closest('.ws-social-module-popup__image-gallery');
          var currentIndex = parseInt($gallery.attr('data-active-index') || 0, 10);
          var nextIndex = currentIndex + ($(this).hasClass('ws-social-module-popup__gallery-arrow--next') ? 1 : -1);
          homePageFn.goToSocialModulePopupGallery($gallery.get(0), nextIndex);
        });

        $(document).on('click', '.ws-social-module-popup__gallery-dot', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var index = parseInt($(this).attr('data-slide-index') || 0, 10);
          homePageFn.goToSocialModulePopupGallery($(this).closest('.ws-social-module-popup__image-gallery').get(0), index);
        });

        // westyle-social-module 视频点击播放/暂停（事件委托，避免克隆后元素未就绪）
        $(document).on('click', '.ws-social-module-popup__video-wrap, .ws-social-module-popup__image-slide--video', function (e) {
          if ($(e.target).closest('.con-close-btn').length) {
            return;
          }
          e.stopPropagation();
          var $wrap = $(this);
          var $video = $wrap.find('.ws-social-module-popup__video');
          var $playBtn = $wrap.find('.ws-social-module-popup__play-btn');
          if (!$video.length || !$playBtn.length) return;
          if ($video[0].paused) {
            $video[0].play();
            $playBtn.hide();
          } else {
            $video[0].pause();
            $playBtn.show();
          }
        });
        $(document).on('play', '.ws-social-module-popup__video', function () {
          $(this).siblings('.ws-social-module-popup__play-btn').hide();
        });
        $(document).on('pause ended', '.ws-social-module-popup__video', function () {
          $(this).siblings('.ws-social-module-popup__play-btn').show();
        });

        // 首页OUR PHILOSOPHY模块点击
        // $(document).on("click", ".ws-our-philosophy-li", function () {
        // // 获取索引index
        // var index = $(this).index();
        // // 定义数据
        // var philosophyList = [
        //     {
        //     img: 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/img_home_Premium_Quality_m_3x_9798807d-a809-44ea-aaca-97e4689e4a48_800x.png?v=1664444378',
        //     title: WS.$t('index.model1_li1_label'),
        //     type: '1',
        //     url: '/pages/about-us'
        //     },
        //     {
        //     img: 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/img_home_Sustainably_Crafted_m_3x_0bb85388-9063-47d6-a511-a88663eb8221_800x.png?v=1664444378',
        //     title: WS.$t('index.model1_li2_label'),
        //     type: '2',
        //     url: '/pages/about-us'
        //     },
        //     {
        //     img: WS.$t('index.model1_li3_image_m'),
        //     title: WS.$t('index.model1_li3_label'),
        //     type: '3',
        //     url: '/pages/about-us'
        //     }
        // ];
        // // 申明弹窗
        // var affirmationPopHtml = `
        //     <!-- 申明弹窗 -->
        //     <div class="ws-vertical-popupbox ws-vertical-popupbox-affirmation">
        //     <div class="ws-vertical-popupbox-overlay"></div>
        //     <div class="ws-vertical-popupbox-con">
        //         <!-- 内容区域 -->
        //         <div class="con-modelbox">
        //         <div class="banner-box banner-box-<%= data.type %> js-lazyload-img">
        //             <img src="<%= data.img %>" />
        //         </div>
        //         <p class="title"><%= data.title %></p>
        //         <% if (data.type == '1') { %>
        //             <p class="p1">${WS.$t('index.model1_li1_pop_info')}</p>
        //         <% } else if (data.type == '2') { %>
        //             <p class="p1">${WS.$t('index.model1_li2_pop_info')}</p>
        //         <% } else if (data.type == '3') { %>
        //             <p class="p1">${WS.$t('index.model1_li3_pop_info')}</p>
        //         <% } %>
        //         <a class="read-more" href="${WS.site.dir}<%= data.url %>?moduleType=<%= data.type %>">${WS.$t('index.model1_read_more')}</a>
        //         </div>
        //         <!-- 删除区域 -->
        //         <div class="con-close-btn">
        //         <img src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic__close_2x_76dbb0f5-a8cd-48e1-b4b1-ceea4fa659f1.png?v=1658907695" />
        //         </div>
        //     </div>
        //     </div>
        // `;
        // // 创建弹窗
        // var htmlStr = WS.tmpl(affirmationPopHtml, philosophyList[index]);
        // // 显示弹窗
        // $('body').append(htmlStr);
        // // 禁止弹窗底部滚动方法
        // WS.ui.popupNoScrollHandle();
        // })

        // 当地址栏带状态为投票参数时，展示弹窗
        // 获取是否携带投票类型
        var voteType = WS.getParam('type');
        if ( voteType === 'vote' && !WS.cookie.get('graecove_vote')) {
        // 网站退出投票提醒弹窗
        var vote_reminder_pop = `
            <div class="ws-main-center-pop ws-main-center-pop-vote">
            <div class="ws-main-center-pop-overlay"></div>
            <div class="ws-main-center-pop-con">
                <a href="https://forms.gle/aPFRF6wR7Y4xcS5x9" class="ws-goto-vote-page js-lazyload-img">
                <img class="ws-vote-reminder-pop-bg" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/brand_partner_b_700x.jpg?v=1691486208" />
                </a>
                <!-- closepop -->
                <img class="ws-center-pop-closebtn" src="https://cdn.shopify.com/s/files/1/0594/1162/8204/files/ls_vote_pop_close.png?v=1654681225" />
            </div>
            </div>
        `;
        // 添加弹窗进页面
        $('body').append(vote_reminder_pop);
        // 上报
        WS.stat({
            eid: WS.ui.reportType['moduleShow'],
            ext1: WS.ui.voteReportMap['showGetStartedSurvey'],
            ext2: 'pop'
        });

        // 投票提醒弹窗点击隐藏
        $(document).on("click", ".ws-main-center-pop-vote .ws-center-pop-closebtn,.ws-main-center-pop-vote .ws-main-center-pop-overlay", function () {
            // 删除模块
            $(this).parents('.ws-main-center-pop').remove();
        })
        // 投票点击进入
        $(document).on("click", ".ws-main-center-pop-vote .ws-goto-vote-page", function () {
            // 上报
            WS.stat({
            eid: WS.ui.reportType['click'],
            ext1: WS.ui.voteReportMap['clickGetStartedSurvey'],
            ext2: 'pop'
            });
            // 储存更改投票状态
            WS.cookie.set('graecove_vote', 1, 24*30);
        })
        }
  
        // 点击icon关闭弹窗
        $(document).on("click", ".ws-vertical-popupbox .con-close-btn,.ws-vertical-popupbox-overlay",function () {
          var noHidePopup = $(this).attr('data-no-hide-popup');
          if (noHidePopup) return;
          WS.ui.hidePopupBox(this);
        });
  
        // ------首页组件点击------
        $(document).on("click", ".ws-slideshow-model .ws-slideshow-imagebox-link", function () {
          // 上报方法
          var bannerLength = $('.ws-slideshow .ws-slideshow-model .ws-slideshow-imagebox-link').length;
          homePageFn.homeComponentClickExposure(JSON.stringify({
            url: $(this).attr('href'),
          }), this, bannerLength > 1 ? '1' : '');
        })
        $(document).on("click", ".ws-text-img-block .ws-container-list-box", function () {
          // 上报方法
          _homeClickReport(this);
        })
        $(document).on("click", ".ws-lego-images_list .images-list-box", function () {
          // 上报方法
          _homeClickReport(this);
        })
        $(document).on("click", ".ws-columns-more-img .ws-listone-li", function () {
          // 上报方法
          _homeClickReport(this);
        })
        $(document).on("click", ".ws-reviews-block .reviews-item", function () {
          // 上报方法
          _homeClickReport(this);
        })
        $(document).on("click", ".ws-img-link-block", function () {
          // 上报方法
          _homeClickReport(this);
        })
          
  
        // 首页点击上报
        function _homeClickReport(that) {
          // 上报方法
          homePageFn.homeComponentClickExposure(JSON.stringify({
            url: $(that).find('a').attr('href'),
          }), that);
        }
      },
  
      // 模块曝光方法
      modelShowHandle: function (dom, reportType, index, data) {
        var threshold = $(dom).find('.ws-featured-collection-listbox').length > 0 ? 0.1 : 0.5;
        var config = {
          threshold: [threshold]
        }
        WS.observe.intersection(dom, function(entries, observer) {
          for (let i = 0, len = entries.length; i < len; i++) {
            var entry = entries[i];
            if (entry.isIntersecting) {
              observer.unobserve(entry.target);
              // 上报(头部两块不用上报)
              if (index > 1) {
                homePageFn.modelShowExposure(reportType, index-1, data);
              }
            }
          }
        }, config)
      },
  
      // 首页模块可见曝光方法上报
      modelShowExposure: function (reportType, index, data) {
        // 上报
        WS.stat({
          eid: WS.ui.reportType['moduleShow'],
          ext1: reportType,
          ext2: index ? `pos=${index}` : '',
          ...data
        });
      },
  
      // 首页组件点击曝光方法
      homeComponentClickExposure: function (param, dom, type = '') {
        // 获取点击的坑位和组件的坑位
        var clickIndex = $(dom).index();
        if (type) {
          clickIndex--;
        }
        var componentIndex = 0;
        // 遍历
        let sectionList = $("body").children('.shopify-section');
        sectionList.forEach((item, index) => {
          if ($(dom).parents('.shopify-section')[0] === item) {
            componentIndex = index;
          }
        })
        // 上报
        WS.stat({
          eid: WS.ui.reportType['click'],
          ext1: WS.ui.homeReportMap['clickHomeSection'],
          ext2: param,
          ext3: `pos=${componentIndex-1}`,
          ext4: `pos=${clickIndex+1}`,
        });
      },
      init: function() {
        homePageFn.insertCollectionModule();
        homePageFn.homepageHandleAll();

        homePageFn.bindSlideshowEditorEvent();
        homePageFn.bindFeaturedCollectionEditorEvent();
        WS.ui.asyncLoadUrls(window.WS_INDEX_LOAD_URLS);
        setTimeout(() => {
          WS.ui.prefetchUrls(window.WS_INDEX_PREFETCH_URLS, 'prefetch');
        }, 300);
      }
    };

    homePageFn.init();

    WS.ui.reportInteractiveTime();

    WS.ui.homePageFn = {
      homeComponentClickExposure: homePageFn.homeComponentClickExposure
    };
  })();
